export const TOKEN_API_URL = '/chat/';
export const CHAT_API_URL = '/chat';

export const HINT_API_URL = '/hint/';
